var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"errors"}},[_c('Error',{staticClass:"error__page",attrs:{"number":_vm.number,"message":_vm.message,"back":true}},[_c('h1',{staticClass:"error__name",domProps:{"innerHTML":_vm._s(_vm.splitNumbers(this.number))}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }